<template>
	<div class='terminology-listing'>
		<div class='container'>
			<div
				v-for="(items, letter) in groupedItems"
				:key="letter"
				class="inner"
			>
				<h2>{{ letter }}</h2>
				<ul>
					<li
						v-for="item in items"
						:key="item.id"
						class="item"
					>
						<h5>{{ item.title }}</h5>
						<p
							class='body'
							v-html='item.content || "No content available"'
						></p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		posts: {
			type: String,
			default: 'Default Value',
		},
		categories: {},
	},
	computed: {
		parsedCategories() {
			if (this.categories) {
				return JSON.parse(this.categories);
			} else {
				return null;
			}
		},
		parsedPosts() {
			if (this.posts) {
				return JSON.parse(this.posts);
			} else {
				return null;
			}
		},
		groupedItems() {
			if (!this.parsedPosts) return {};

			// Group items alphabetically by the first letter of their title
			const grouped = this.parsedPosts.reduce((acc, item) => {
				const letter = item.title.charAt(0).toUpperCase(); // Get the first letter and capitalize it
				if (!acc[letter]) {
					acc[letter] = [];
				}
				acc[letter].push(item);
				return acc;
			}, {});

			// Sort the items alphabetically within each group
			Object.keys(grouped).forEach((letter) => {
				grouped[letter].sort((a, b) => a.title.localeCompare(b.title));
			});

			// Sort the groups alphabetically by their keys
			return Object.keys(grouped)
				.sort()
				.reduce((sortedAcc, key) => {
					sortedAcc[key] = grouped[key];
					return sortedAcc;
				}, {});
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.terminology-listing {
	margin-top: 32px;

	.inner {
		margin-bottom: 40px;
		grid-column: 3 / span 8;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
			margin-bottom: 24px;
		}

		h2 {
			margin: 0 0 32px;

			@media (max-width: $mobile-xl) {
				margin-bottom: 24px;
			}
		}

		ul {
			list-style: none;
			padding: 0;
			margin: 0;

			li {
				h5 {
					margin: 0 0 10px;
				}

				p {
					margin: 0 0 20px;
				}
			}
		}
	}
}
</style>
